import { Base, Container, Grid, Image, Section } from '@/components/Core'
import { Button } from '@/components/Ui'
import { Lib } from '@/types'
import clsx from 'clsx'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import SectionImageTextFragment from './query'

export interface SectionImageTextProps {
  data: Lib.FragmentOf<typeof SectionImageTextFragment>
}

export type SectionImageTextData = Lib.FragmentOf<
  typeof SectionImageTextFragment
> & {
  _modelApiKey: 'section_image_text'
  __typename: 'SectionImageTextRecord'
  id: string
}

const SectionImageText = ({ data }: SectionImageTextProps) => {
  const d = readFragment(SectionImageTextFragment, data)

  return (
    <Section
      className={'pt-vertical-main pb-vertical-large'}
      mainWrapper={false}
      sectionName={d._modelApiKey}
      anim="section-fade-in"
    >
      <Container>
        <Grid>
          <Base
            className="col-span-12 lg:col-span-5 lg:col-start-2"
            anim="fade-in"
          >
            {d.image && (
              <Image data={d.image} imgClassName="overflow-hidden rounded-lg" />
            )}
          </Base>
          {(d.numbers || d.text) && (
            <Base
              className={
                'gap-y-vertical-main col-span-12 flex flex-col justify-between lg:col-span-5'
              }
              anim="fade-in"
              animDelayFactor={1}
            >
              <div>
                <div
                  className={clsx(
                    'gap-md md:gap-vertical-small grid list-none grid-cols-[auto_1fr] md:mb-6 md:flex md:flex-wrap',
                    d.numbers.length > 3 ? 'justify-between' : ''
                  )}
                >
                  {d.numbers.map((item, index) => (
                    <Base
                      key={index}
                      className="flex flex-col max-md:w-1/3"
                      anim="fade-in"
                      animDelayFactor={index + 1}
                    >
                      <span className="h2">{item.number}</span>{' '}
                      <span className="text-style-large text-lg max-sm:text-neutral-600">
                        {item.description}
                      </span>
                    </Base>
                  ))}
                </div>

                {d.text && (
                  <div
                    className="text-style-large"
                    dangerouslySetInnerHTML={{ __html: d.text }}
                  />
                )}
              </div>

              <Base anim="fade-in" animDelayFactor={1}>
                {d.link && <Button data={d.link} />}
              </Base>
            </Base>
          )}
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionImageText)
